const QuestionTitle = (props: { question: string, questionIndex: Number }) => {
    return (
        <>
            <dt className={props.questionIndex ? "" : "open"}>{props.question}</dt>
        </>
    );
}

export default QuestionTitle;
